module.exports = __webpack_public_path__ + "static/media/image16.ba6ae4d9.JPG";